import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";

const AI_SUMMARY_ENDPOINT: keyof paths = '/Ai/GetSummary';
export type AiSearchSummaryResponseData = components["schemas"]["AiSummaryOutput"]


export type HomeAiSearchResponseModel = {
    data: {
        summary: string;
        isRelatedToConsumerPreferences: boolean;
        isRelatedToReportPro: boolean;
    };
    isLoading: boolean;
}

export function useAiSearchSummary(query: string): HomeAiSearchResponseModel {
    const { 
        data, 
        isLoading, 
    } = useAxios<AiSearchSummaryResponseData>({
        method: 'get',
        url: `${AI_SUMMARY_ENDPOINT}?query=${encodeURIComponent(query)}`,
        lazy: !query,
    });

    return {
        data: {
            summary: data?.summary || '',
            isRelatedToConsumerPreferences: data?.dataRelatedToConsumerPreferences ?? false,
            isRelatedToReportPro: data?.dataRelatedToReportPro ?? false,
        },
        isLoading,
    };

}